import "./Hero.scss";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

export default function Hero() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="hero-section">
      <div className="background">
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          className="swiper"
          spaceBetween={10}
          slidesPerView={1}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }}
          direction="horizontal"
          observeParents={true}
          parallax={true}
          touchEventsTarget="container"
        >
          <SwiperSlide>
            <img
              src="https://alexfish.s3.eu-north-1.amazonaws.com/1737554134707_%C3%90%C2%A4%C3%90%C2%B0%C3%90%C2%B3%C3%91%C2%80%C3%90%C2%B8.webp"
              className="alex-fish"
              alt="Alex Fish"
            ></img>
          </SwiperSlide>
          <SwiperSlide>
            <img
              src="https://alexfish.s3.eu-north-1.amazonaws.com/1737554263349_%C3%90%C2%9B%C3%90%C2%BE%C3%90%C2%B1%C3%91%C2%81%C3%91%C2%82%C3%90%C2%B5%C3%91%C2%80.webp"
              className="alex-fish"
              alt="Alex Fish"
            ></img>
          </SwiperSlide>
          <SwiperSlide>
            <img
              src="https://alexfish.s3.eu-north-1.amazonaws.com/1737554230556_%C3%90%C2%9F%C3%91%C2%8A%C3%91%C2%80%C3%90%C2%B6%C3%90%C2%B5%C3%90%C2%BD_%C3%90%C2%BA%C3%90%C2%B0%C3%90%C2%BB%C3%90%C2%BA%C3%90%C2%B0%C3%90%C2%BD.webp"
              className="alex-fish"
              alt="Alex Fish"
            ></img>
          </SwiperSlide>
        </Swiper>
        <div className="title">
          <h1>
            <span className="blue">Alex</span> <span className="red">Fish</span>{" "}
            Delivery
          </h1>
        </div>
        <div className="cta">
          <div className="text">
            <p>{t("hero-cta")}</p>
          </div>
          <div className="cta-button">
            <button
              onClick={() => {
                localStorage.setItem("activeMenu", 9);
                navigate("/menu/category/10");
              }}
            >
              {t("hero-see-menu")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
